'use client';

import { MouseEvent, SyntheticEvent, useCallback, useState } from 'react';

import { SystemUpdate } from '../../icons';
import { AppDownloaderTabContent } from '../AppDownloaderTabContent';
import { ClickAwayListener } from '../ClickAwayListener';
import { IconButton } from '../IconButton';
import { Tab } from '../Tab';
import { Tabs } from '../Tabs';

import { AppDownloaderPopper } from './styled';
import { AppDownloaderProps } from './types';

export const AppDownloader = (props: AppDownloaderProps) => {
  const { tabs, icon } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null);
  const [tabsValue, setTabsValue] = useState(0);
  const popperOpen = Boolean(anchorEl);
  const Icon = icon || <SystemUpdate />;

  const handleTabsChange = (event: SyntheticEvent, newValue: number) => {
    setTabsValue(newValue);
  };

  const handleIconButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleOutsideClick = () => {
    setAnchorEl(null);
  };

  const renderTabs = useCallback(
    () => tabs.map((item) => <Tab key={item.appLink.url} label={item.title} />),
    [tabs],
  );

  const renderTabsContent = useCallback(
    () =>
      tabs.map((item, index) => {
        if (tabsValue === index) {
          return <AppDownloaderTabContent {...item} key={item.appLink.url} />;
        }

        return null;
      }),
    [tabs, tabsValue],
  );

  return (
    <ClickAwayListener onClickAway={handleOutsideClick}>
      <div>
        <IconButton onClick={handleIconButtonClick}>{Icon}</IconButton>

        <AppDownloaderPopper open={popperOpen} anchorEl={anchorEl}>
          <Tabs
            variant="fullWidth"
            value={tabsValue}
            onChange={handleTabsChange}
          >
            {renderTabs()}
          </Tabs>
          {renderTabsContent()}
        </AppDownloaderPopper>
      </div>
    </ClickAwayListener>
  );
};
